$(document).ready(function() {
    // 平滑滚动导航
    $('a[href^="#"]').on('click', function(e) {
        e.preventDefault();
        var target = $(this.getAttribute('href'));
        if (target.length) {
            $('html, body').animate({
                scrollTop: target.offset().top - 80
            }, 800);
        }
    });

    // 产品轮播功能
    const productImages = [
        'https://neofirefly.com/cdn/shop/files/specs_3_1.webp',
        'https://neofirefly.com/cdn/shop/files/specs_3_2.webp', 
        'https://neofirefly.com/cdn/shop/files/specs_3_3.webp'
    ];
    let currentProductIndex = 0;
    let autoCarouselInterval = null;
    let isFirstLoad = true;

    function updateProductDisplay(useAnimation = true) {
        const $image = $('.product-image');
        
        if (useAnimation && !isFirstLoad) {
            // 淡出
            $image.css('opacity', '0.1');
            // 等待淡出完成后再切换图片
            setTimeout(function() {
                switchImage($image);
            }, 150); // 一半的过渡时间，实现平滑切换
        } else {
            // 首次加载或不需要动画时直接切换
            switchImage($image, false);
            isFirstLoad = false;
        }
    }

    function switchImage($image, fadeIn = true) {
        // 移除之前的load事件监听器，避免重复绑定
        $image.off('load');
        $image.attr('src', productImages[currentProductIndex]);
        
        if (fadeIn) {
            // 等待图片加载完成后再淡入
            $image.one('load', function() {
                $image.css('opacity', '1');
            });
            // 如果图片已经缓存，load事件可能不会触发，所以也设置一个fallback
            if ($image[0].complete) {
                $image.css('opacity', '1');
            }
        } else {
            // 不需要淡入时直接显示
            $image.css('opacity', '1');
        }
    }

    // 手动切换
    $('#next-btn').on('click', function() {
        currentProductIndex = (currentProductIndex + 1) % productImages.length;
        updateProductDisplay();
        resetAutoCarousel();
    });

    $('#prev-btn').on('click', function() {
        currentProductIndex = (currentProductIndex - 1 + productImages.length) % productImages.length;
        updateProductDisplay();
        resetAutoCarousel();
    });

    // 自动轮播功能（仅移动端）
    function startAutoCarousel() {
        if (window.innerWidth <= 600) {
            autoCarouselInterval = setInterval(function() {
                currentProductIndex = (currentProductIndex + 1) % productImages.length;
                updateProductDisplay();
            }, 5000); // 每3秒切换一次
        }
    }

    function stopAutoCarousel() {
        if (autoCarouselInterval) {
            clearInterval(autoCarouselInterval);
            autoCarouselInterval = null;
        }
    }

    function resetAutoCarousel() {
        stopAutoCarousel();
        startAutoCarousel();
    }

    // 页面加载时检查是否为移动端
    if (window.innerWidth <= 600) {
        startAutoCarousel();
        showEmailSignupForm('mobile')
    }
    
    // 窗口大小改变时重新检查
    $(window).on('resize', function() {
        if (window.innerWidth <= 600) {
            if (!autoCarouselInterval) {
                startAutoCarousel();
            }
            // email-signup-block 隐藏标签的父级
            showEmailSignupForm('mobile')
            // 复制一份$('.email-signup-block') 元素加到body
            // $('body').append($('.email-signup-block').clone());
        } else {
            stopAutoCarousel();
            showEmailSignupForm('web')
        }
    });

    // 表单类显示
    function showEmailSignupForm(type) {
        if(type === 'mobile') {
            $('.email-signup-block').parent().parent().parent().parent().hide()
            $('.mobile-email-signup-open').show()
            $('.mobile-email-signup-content').empty().append($('.email-signup-block').first().clone())
        } else {
            $('.email-signup-block').parent().parent().parent().parent().show()
            $('.mobile-email-signup-open').hide()
        }
    }
    // 订阅功能
    function handleSubscribe(emailInputId, buttonId) {
        $(buttonId).on('click', function(e) {
            e.preventDefault();
            const email = $(emailInputId).val().trim();
            
            if (email === '') {
                alert('Please enter an email address');
                return;
            }
            
            if (!isValidEmail(email)) {
                alert('Please enter a valid email address');
                return;
            }
            
            // 模拟订阅成功
            $(this).text('Subscribed!').css('background', '#28a745');
            $(emailInputId).val('');
            
            setTimeout(() => {
                $(this).text('Subscribe').css('background', '#ff6b35');
            }, 3000);
        });
    }

    // 邮箱验证
    function isValidEmail(email) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    }

    // 绑定订阅按钮
    handleSubscribe('#email-input', '#subscribe-btn');
    handleSubscribe('#footer-email-input', '#footer-subscribe-btn');

    // 回车键订阅
    $('#email-input, #footer-email-input').on('keypress', function(e) {
        if (e.which === 13) {
            const buttonId = $(this).attr('id') === 'email-input' ? '#subscribe-btn' : '#footer-subscribe-btn';
            $(buttonId).click();
        }
    });

    // 产品展示悬停效果
    $('.product-item').hover(
        function() {
            $(this).css('transform', 'rotateY(15deg) scale(1.05)');
        },
        function() {
            $(this).css('transform', 'rotateY(0deg) scale(1)');
        }
    );

    // 功能卡片悬停效果
    $('.feature-item').hover(
        function() {
            $(this).find('.feature-icon').css('transform', 'scale(1.1)');
        },
        function() {
            $(this).find('.feature-icon').css('transform', 'scale(1)');
        }
    );

    // 材料部分悬停效果
    // $('.material-item ').hover(
    //     function() {
    //         $(this).find('img').css('transform', 'scale(1.05)');
    //     },
    //     function() {
    //         $(this).find('img').css('transform', 'scale(1)');
    //     }
    // );

    // 滚动效果（移除header相关代码）

    // 动画效果 - 元素进入视口时显示
    function animateOnScroll() {
        $('.feature-item, .material-item, .specs-table').each(function() {
            const elementTop = $(this).offset().top;
            const elementBottom = elementTop + $(this).outerHeight();
            const viewportTop = $(window).scrollTop();
            const viewportBottom = viewportTop + $(window).height();
            if (elementBottom > viewportTop && elementTop < viewportBottom) {
                $(this).addClass('animate-in');
            }
        });
    }

    // 添加动画样式
    $('<style>')
        .prop('type', 'text/css')
        .html(`
            .feature-item, .material-item, .specs-table {
                opacity: 0;
                transform: translateY(30px);
                transition: all 0.6s ease;
            }
            
            .feature-item.animate-in, .material-item.animate-in, .specs-table.animate-in {
                opacity: 1;
                transform: translateY(0);
            }
        `)
        .appendTo('head');

    // 监听滚动事件
    $(window).on('scroll', animateOnScroll);
    
    // 页面加载时执行一次
    animateOnScroll();

    // 兼容性徽章点击效果
    $('.badge').on('click', function() {
        $(this).css('transform', 'scale(0.95)');
        setTimeout(() => {
            $(this).css('transform', 'scale(1)');
        }, 150);
    });

    // 规格表格行悬停效果
    $('.specs-table tr').hover(
        function() {
            $(this).css('background', '#f9f9f9');
        },
        function() {
            $(this).css('background', 'transparent');
        }
    );

    // 轮播按钮禁用状态
    function updateCarouselButtons() {
        // 这里可以添加按钮禁用逻辑，如果需要的话
    }

    // 键盘导航支持
    $(document).on('keydown', function(e) {
        if (e.key === 'ArrowLeft') {
            $('#prev-btn').click();
        } else if (e.key === 'ArrowRight') {
            $('#next-btn').click();
        }
    });

    // 触摸设备支持
    let touchStartX = 0;
    let touchEndX = 0;

    $('.product-carousel').on('touchstart', function(e) {
        touchStartX = e.originalEvent.touches[0].clientX;
    });

    $('.product-carousel').on('touchend', function(e) {
        touchEndX = e.originalEvent.changedTouches[0].clientX;
        handleSwipe();
    });

    function handleSwipe() {
        const swipeThreshold = 50;
        const diff = touchStartX - touchEndX;
        
        if (Math.abs(diff) > swipeThreshold) {
            if (diff > 0) {
                // 向左滑动，显示下一个
                currentProductIndex = (currentProductIndex + 1) % productImages.length;
            } else {
                // 向右滑动，显示上一个
                currentProductIndex = (currentProductIndex - 1 + productImages.length) % productImages.length;
            }
            updateProductDisplay();
            resetAutoCarousel();
        }
    }

    // 页面加载完成后的初始化
    updateProductDisplay();
    
    // 添加加载动画
    $('body').addClass('loaded');
    
    // 添加加载样式
    $('<style>')
        .prop('type', 'text/css')
        .html(`
            body {
                opacity: 0;
                transition: opacity 0.5s ease;
            }
            
            body.loaded {
                opacity: 1;
            }
        `)
        .appendTo('head');

    // 如果是感谢弹窗参数，弹出弹窗
    if(window.location.search==="?customer_posted=true"){
        if(window.innerWidth <= 600) {
            $('#mobile-email-signup').css('display', 'flex');
            $('.mobile-email-signup-content').hide()
            $('.mobile-email-signup-success').show()
            $('.close-mobile-email-signup').show()
        }else{
            $("#thanks-modal").css("display","flex");
        }
    }
    $(document).on('click', '#close-thanks-modal', function(){
        // 清除链接上的参数
        window.history.replaceState({}, document.title, window.location.pathname);
        $('#thanks-modal').fadeOut(200);
    });

    // Mobile Email Signup 弹窗关闭功能
    $(document).on('click', '.close-mobile-email-signup', function(){
        $('#mobile-email-signup').css('display', 'none');
        window.history.replaceState({}, document.title, window.location.pathname);
    });
    $(document).on('click', '.close-mobile-email-signup-icon', function(){
        $('#mobile-email-signup').css('display', 'none');
        $('.mobile-email-signup-content').show()
        $('.mobile-email-signup-success').hide()
        $('.close-mobile-email-signup').hide()
        window.history.replaceState({}, document.title, window.location.pathname);
    });
    // 点击弹窗外部关闭
    $(document).on('click', '#mobile-email-signup', function(e){
        if ($(e.target).attr('id') === 'mobile-email-signup') {
            $(this).css('display', 'none');
            $('.mobile-email-signup-content').show()
            $('.mobile-email-signup-success').hide()
            $('.close-mobile-email-signup').hide()
            window.history.replaceState({}, document.title, window.location.pathname);
        }
    });

    // 点击按钮打开弹窗
    $(document).on('click', '.mobile-email-signup-open-button', function(){
        $('#mobile-email-signup').css('display', 'flex');
    });

    // 使用 Intersection Observer 实现真正的懒加载
    let imageObserver = null;
    if ('IntersectionObserver' in window) {
        imageObserver = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const img = entry.target;
                    const dataSrc = img.getAttribute('data-src');
                    if (dataSrc) {
                        // 使用 1x1 透明图片作为占位符
                        if (!img.src || img.src.includes('data:image')) {
                            img.src = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1 1"%3E%3C/svg%3E';
                        }
                        img.src = dataSrc;
                        img.removeAttribute('data-src');
                        img.classList.remove('lazy');
                        observer.unobserve(img);
                        ebugger
                    }
                }
            });
        }, {
            // 在图片距离视口 200px 时开始加载
            rootMargin: '200px'
        });

        // 观察所有带有 data-src 的图片
        const lazyImages = document.querySelectorAll('img[data-src]');
        lazyImages.forEach(img => {
            // 设置占位符
            if (!img.src) {
                img.src = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1 1"%3E%3C/svg%3E';
            }
            imageObserver.observe(img);
        });

        // 函数：加载指定容器内的所有懒加载图片
        function loadLazyImagesInContainer(container) {
            const lazyImages = container.querySelectorAll('img[data-src]');
            lazyImages.forEach(img => {
                const dataSrc = img.getAttribute('data-src');
                if (dataSrc) {
                    img.src = dataSrc;
                    img.removeAttribute('data-src');
                    img.classList.remove('lazy');
                    if (imageObserver) {
                        imageObserver.unobserve(img);
                    }
                }
            });
        }

        // 当弹窗显示时，立即加载弹窗中的图片
        $('#mobile-email-signup, #thanks-modal').on('shown', function() {
            loadLazyImagesInContainer(this);
        });
        
        // 监听弹窗显示（使用 MutationObserver 或直接监听）
        const modalObserver = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
                    const target = mutation.target;
                    const display = window.getComputedStyle(target).display;
                    if (display === 'flex' || display === 'block') {
                        loadLazyImagesInContainer(target);
                    }
                }
            });
        });

        // 观察弹窗元素的 display 变化
        const thanksModal = document.getElementById('thanks-modal');
        const mobileEmailSignup = document.getElementById('mobile-email-signup');
        if (thanksModal) {
            modalObserver.observe(thanksModal, { attributes: true, attributeFilter: ['style'] });
        }
        if (mobileEmailSignup) {
            modalObserver.observe(mobileEmailSignup, { attributes: true, attributeFilter: ['style'] });
        }
    }

});